import React from "react";
import { CASINOS } from "../mock";
import CasinoCard from "../components/CasinoCard";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <main>
        {/* Hero */}
        <section className="mx-auto max-w-6xl px-5 pt-14 pb-10 text-center">
          <h1
            className="cp-fade-up mx-auto max-w-3xl text-3xl font-bold leading-tight sm:text-4xl md:text-5xl"
            style={{ color: "#ffffff" }}
          >
            Best Sweepstakes Casinos &amp; Sportsbooks 2026
          </h1>
          <p
            className="cp-fade-up mx-auto mt-4 max-w-2xl text-sm sm:text-base"
            style={{ color: "var(--cp-muted)", animationDelay: "80ms" }}
          >
            Ranked on offer value, redemption speed, game depth and availability.
          </p>
        </section>

        {/* Top picks */}
        <section id="top-picks" className="mx-auto max-w-6xl px-5">
          <div className="flex flex-col gap-4">
            {CASINOS.map((c, i) => (
              <CasinoCard key={c.slug} casino={c} delay={i * 90} />
            ))}
          </div>
        </section>

        {/* Disclaimer */}
        <section className="mx-auto max-w-6xl px-5 pt-10">
          <div
            className="cp-fade-up rounded-lg px-5 py-4 text-sm"
            style={{
              background: "rgba(255,255,255,0.02)",
              borderLeft: "3px solid var(--cp-green)",
              animationDelay: "120ms",
            }}
          >
            <span className="font-semibold" style={{ color: "#ffffff" }}>
              Play for fun, never for income.
            </span>{" "}
            <span style={{ color: "var(--cp-muted)" }}>
              You must be 18+ (21+ at some operators). Sweepstakes casinos are not
              real money gambling and Gold Coins have no monetary value.
            </span>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HomePage;
